import type { ReactNode } from "react";

export default function SectionHeading({
  eyebrow,
  title,
  description,
  action,
  className = "",
}: {
  eyebrow: string;
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={`flex flex-col md:flex-row md:items-end md:justify-between gap-5 mb-10 ${className}`}
    >
      <div className="max-w-2xl">
        <span className="eyebrow">{eyebrow}</span>
        <h2 className="mt-4 font-display text-3xl lg:text-5xl font-extrabold tracking-tight leading-[1.02] text-foreground">
          {title}
        </h2>
        {description && (
          <p className="mt-3 text-muted-foreground leading-relaxed">
            {description}
          </p>
        )}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}
